import React, { useState } from 'react';

import { QuestionIcon } from 'features/order-tracker/shared-components/svg';

import {
  BeforeEngineerVisitAccordion,
  DuringEngineerVisitAccordion,
  EngineerVisitAccordion,
  MissedEngineerVisitAccordion,
} from './components';
import { ENGINEER_VISIT_ACCORDION_TITLE, ENGINEER_VISIT_LEARN_MORE } from './constants';

import styles from './styles.module.scss';

export const EngineerVisitSection: React.FC = () => {
  const [activeAccordionIndex, setActiveAccordionIndex] = useState(-1);
  const accordionData = [
    {
      title: ENGINEER_VISIT_ACCORDION_TITLE.before,
      content: <BeforeEngineerVisitAccordion />,
    },
    {
      title: ENGINEER_VISIT_ACCORDION_TITLE.during,
      content: <DuringEngineerVisitAccordion />,
    },
    { title: ENGINEER_VISIT_ACCORDION_TITLE.missed, content: <MissedEngineerVisitAccordion /> },
  ];

  const setActiveAccordionInfo = (index: number): void => {
    setActiveAccordionIndex(index);
  };

  return (
    <div className={styles.engineerVisitContainer}>
      <div className={styles.learnMore}>
        <QuestionIcon />
        <p>{ENGINEER_VISIT_LEARN_MORE}</p>
      </div>
      <div className={styles.accordionsContainer}>
        {accordionData.map(({ title, content }, index) => (
          <EngineerVisitAccordion
            key={title}
            title={title}
            content={content}
            index={index}
            isExpanded={index === activeAccordionIndex}
            setActiveAccordionInfo={setActiveAccordionInfo}
          />
        ))}
      </div>
    </div>
  );
};
